
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/practitioners/therapist-info",
      function () {
        return require("private-next-pages/article/practitioners/therapist-info/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/practitioners/therapist-info"])
      });
    }
  